export default class InvalidArgumentError extends Error {
  constructor(argument: string, type: string) {
    super(`Invalid or missing argument "${argument}". It must be of ${type} type.`)
    this.name = this.constructor.name
  }
}
